import styled from "@emotion/styled";
import { Box, Flex, Text, theme } from "@xometry/xometry_loft";

export const DisabledFormHeader = styled(Flex)`
  flex-direction: column;
  padding-bottom: ${theme.space[3]};
  margin-bottom: ${theme.space[3]};
  border-bottom: ${theme.borders[0]} solid ${theme.colors.darkBlues[10]};
`;

export const DisabledFormItem = styled(Flex)`
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: ${theme.space[3]};
`;

export const PartMarkingItem = styled(Text)`
  display: inline-block;
  background-color: ${theme.colors.blues[10]};
  color: ${theme.colors.blues[100]};
  border-radius: ${theme.borderRadius[1]};
  padding: ${theme.space[1]} ${theme.space[2]};
  margin-right: ${theme.space[2]};
  margin-bottom: ${theme.space[1]};
`;

export const PartMarkingContainer = styled(Box)`
  display: block;
`;

export const PartOrderTotal = styled(Flex)`
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: ${theme.space[3]};
`;

export const CloseButtonWrapper = styled(Box)`
  text-align: right;
  margin-top: ${theme.space[5]};
  padding-top: ${theme.space[5]};
  border-top: 1px solid ${theme.colors.darkBlues[10]};
`;
